import { SYSCON } from '@/const/const'
import User from '../../modules/user'

const ImgArr = ['starter.svg', 'premium.svg', 'proffessional.svg']
const Imgs = ImgArr.map(item => require('@/common/images/svgs/' + item))
const Senior = require('@/common/images/senior.png')
const TopSenior = require('@/common/images/top-senior.png')
// const FreeMonthStr = '免费试用两个月'
const user = new User()
const FreeMonthSeniorStr = '免费试用一个月'
const TryBtnStr = '立即试用'
const BuyBtnStr = '购买'
const ConsultStr = '咨询价格'
const BuyType = SYSCON.BuyType
const TryType = SYSCON.TryType
const getProds = async() => {
  const prodList = await user.getProds()
  const ProductItems = []
  prodList.forEach((val, index) => {
    // 已发布
    const ProdWithReleased = '200000.10'
    if (val.status !== ProdWithReleased) return
    ProductItems.push({
      title: val.nm,
      price: val.minPriceDes,
      contents: val.des,
      freeStr: FreeMonthSeniorStr,
      buyType: BuyType,
      tryType: TryType
    })
    if (val.nm === '高级代账版') {
      ProductItems[index].img = TopSenior.default
      ProductItems[index].consultStr = ConsultStr
    } else if (val.nm === '代账版') {
      ProductItems[index].img = Senior.default
      ProductItems[index].buyStr = BuyBtnStr
      ProductItems[index].tryStr = TryBtnStr
    } else {
      ProductItems[index].img = Imgs[index] ? Imgs[index].default : ''
      ProductItems[index].buyStr = BuyBtnStr
      ProductItems[index].tryStr = TryBtnStr
    }
  })
  return ProductItems
}
// const ProductItems = [
//   {
//     img: Imgs[0].default,
//     title: '普及版',
//     price: '3账套 ￥800/年起',
//     contents: [
//       '适用于有财务核算需求的企业。',
//       '自动生成财务报表（资产负债表、现金流量表、利润表）。',
//       '录凭证出报表、期初初始化期末结转结账、智能凭证、辅助核算、原始凭证、固定资产等基础功能。'
//     ],
//     freeStr: FreeMonthSeniorStr,
//     buyStr: BuyBtnStr,
//     tryStr: TryBtnStr,
//     buyType: BuyType,
//     tryType: TryType
//   },
//   {
//     img: Imgs[2].default,
//     title: '标准版',
//     price: '1账套 ￥500/年起',
//     contents: [
//       '适用于有一体化财务管理需求的企业。',
//       '具有层级管理和组织架构，组织架构层层展示；多角色权限按需分配。',
//       '录凭证出报表、期初初始化期末结转结账等基 础功能。智能凭证、辅助核算、原始凭证、固定资产等强化功能。'
//     ],
//     freeStr: FreeMonthSeniorStr,
//     buyStr: BuyBtnStr,
//     tryStr: TryBtnStr,
//     buyType: BuyType,
//     tryType: TryType
//   },
//   {
//     img: Imgs[1].default,
//     title: '高级版',
//     price: '1账套 ￥2000/年起',
//     contents: [
//       '适用于对财务管理要求更高的企业。',
//       '具有层级管理和组织架构，组织架构层层展示；多角色权限按需分配。',
//       '录凭证出报表、期初初始化期末结转结账等基 础功能。智能凭证、辅助核算、原始凭证、固定资产等强化功能。',
//       '专属客服，定制化API接口。'
//     ],
//     freeStr: FreeMonthSeniorStr,
//     buyStr: BuyBtnStr,
//     tryStr: TryBtnStr,
//     buyType: BuyType,
//     tryType: TryType
//   },
//   {
//     img: Senior.default,
//     title: '代账版',
//     price: '50账套 ￥7500/年起',
//     contents: [
//       '适用于需要组织架构管理、财务管理要求较高的代账机构。',
//       '兼容市面上大多数财务产品的账套迁移，支持不同财务产品导入同一账套。',
//       '专为代账会计和代账机构设计，在线记账，小程序端随时查看报表，提升代账效益。',
//       '具有层级管理和组织架构，组织架构层层展示；多角色权限按需分配。'
//     ],
//     freeStr: FreeMonthSeniorStr,
//     buyStr: BuyBtnStr,
//     tryStr: TryBtnStr,
//     buyType: BuyType,
//     tryType: TryType
//   },
//   {
//     img: TopSenior.default,
//     title: '高级代账版',
//     price: '价格请咨询',
//     contents: [
//       '适用于需要组织架构管理、财务管理要求较高的代账机构。',
//       '能够兼容市面上大多数财务产品的账套迁移，支持不同财务产品导入同一账套。',
//       '专为代账会计和代账机构设计，在线记账，小程序端随时查看报表，提升代账效益。',
//       '完善的层级管理和组织架构，包含人事管理，客户接洽单管理和工商服务管理。'
//     ],
//     buyType: BuyType,
//     tryType: TryType,
//     consultStr: ConsultStr
//   }

// ]

export { getProds }
